/** Store zustand de acciones permitidas: cachea por usuario|empresa|sucursal, evita duplicar llamadas en vuelo y expone cargar y reset. */
import { create } from "zustand";
import { GETAccionesPermitidas, type AccionPermitida } from "@/api";

interface CargarAccionesArgs {
  codUsuario: string;
  codEmpresa: string;
  codSucursal: string;
  forzar?: boolean;
}

interface AccionesPermitidasState {
  acciones: AccionPermitida[] | null;
  cargando: boolean;
  error: unknown;
  clave: string;
  promesa: Promise<void> | null;
  cargar: (args: CargarAccionesArgs) => Promise<void>;
  reset: () => void;
}

export const useAccionesPermitidasStore = create<AccionesPermitidasState>((set, get) => ({
  acciones: null,
  cargando: false,
  error: null,
  clave: "",
  promesa: null,

  cargar: async ({ codUsuario, codEmpresa, codSucursal, forzar = false }) => {
    const state = get();
    const clave = `${codUsuario}|${codEmpresa}|${codSucursal}`;

    if (!forzar && state.acciones && state.clave === clave) return;
    if (state.clave === clave && state.cargando) return;
    const enVuelo = state.promesa;
    if (enVuelo) return enVuelo;

    const promesa = (async () => {
      set({ cargando: true, error: null, clave });
      const res = await GETAccionesPermitidas(codEmpresa, codSucursal);
      if (res.success) {
        set({ acciones: res.data ?? [], cargando: false, error: null });
      } else {
        set({ acciones: null, cargando: false, error: res.error });
      }
    })().finally(() => set({ promesa: null }));

    set({ promesa });
    return promesa;
  },

  reset: () => set({ acciones: null, cargando: false, error: null, clave: "", promesa: null }),
}));